const getReturningUserData = require("../../run/returningUser/getReturningUserData");
const hideAllWhitepaper2024ReturningUserContainersOnThePage = require("../../run/whitepaper2024/hideAllWhitepaper2024ReturningUserContainersOnThePage");
const submitFormToMarketo = require("../../run/marketo/submitFormToMarketo");
const removeSectionGates = require("../../run/whitepaper2024/removeSectionGates");
const showSuccessForAllWhitepaper2024Forms = require("../../run/whitepaper2024/showSuccessForAllWhitepaper2024Forms");

/**
 * @return {void}
 */
module.exports = async function whenWhitepaper2024ReturningUserShowContentClicked() {
    const returningUserData = getReturningUserData();

    try {
        await submitFormToMarketo(returningUserData);

        removeSectionGates();
    } catch (e) {
        alert("We could not load returning user data. Please try again!");
        console.error(e);
    }

    hideAllWhitepaper2024ReturningUserContainersOnThePage();

    showSuccessForAllWhitepaper2024Forms();
}
